<template>
    <div class="basic-uj" v-if="pageIndex == 11">
        <h1>
            {{$t("UJ.section11.title")}}
            <!-- <span>{{$t("UJ.section11.span")}}</span> -->
        </h1>
        <!-- <h1>{{$t('UJ.successTitle')}}</h1> -->
        <!-- <p class="desc">{{$t('UJ.question')}}</p> -->
        <p class="desc">{{$t("UJ.section11.desc1")}}</p>
        <p class="desc mb35 mt20" v-html="$t('UJ.section11.desc2')"></p>
        <div class="after-success">
            <a class="app-store" :href="download_app"></a>
            <a class="profile" href="/profile/">{{$t("UJ.section11.desc4")}}</a>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.basic-uj {
    h1 {
        font-family: GothamBook;
        font-size: 28px;
        line-height: 1.5;
        letter-spacing: 0.7px;
        color: var(--dark-indigo);
        margin-bottom: 35px;
        span {
            color: var(--windows-blue);
        }
    }
    .desc {
        font-family: GothamBook;
        font-size: 14px;
        line-height: 1.5;
        color: #333333;
        &.mb35 {
            margin-bottom: 35px;
        }
        &.mt20 {
            margin-top: 20px;
        }
    }
    span {
        font-family: GothamMedium;
    }
    .after-success {
        display: flex;
        align-items: center;
        .app-store {
            display: inline-block;
            position: relative;
            width: 131px;
            height: 44px;
            background: url("../../../../website_20/static/img/UJ/app-store-badge-us-black@2x.png")
                no-repeat;
            background-size: contain;
            &:after {
                content: "";
                display: inline-block;
                position: absolute;
                top: 9px;
                left: 10px;
                width: 21px;
                height: 100%;
                background-repeat: no-repeat;
                background-size: contain;
            }
            &:hover {
                transition: transform 0.2s ease-in-out;
                transform: scale3d(1.04, 1.04, 1);
                &:after {
                    background-image: url("../../../../website_20/static/img/apple-logo-colorful.svg");
                }
            }
        }
        .profile {
            margin-left: 32px;
        }
    }
}
</style>

<script>
export default {
    name: "UJSuccess",
    props: {
        nextMethod: { type: Function },
        pageIndex: {}
    },
    data() {
        return {
            download_app: ""
        };
    },
    mounted() {
        let lang;
        if (this.$root.cookie.acreage != "en") {
            lang = "cn";
        } else {
            lang = "us";
        }
        this.download_app = `https://itunes.apple.com/${lang}/app/property-passbook/id1435294143?mt=8`;
    }
};
</script>



// WEBPACK FOOTER //
// src/components/userJourney/UJSuccess.vue